<template>
  <div class="course" v-if="!loading">
    <renderer
      :module="stepData.module"
      :step="stepData.number"
      :stepLength="moduleData.steps.length"
      :markdownData="stepData.markdown"
    ></renderer>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";
import Renderer from "@/components/Renderer.vue";
import CourseService from "@/services/course.service";
import config from "../config";

export default {
  name: "Course",
  components: {
    Renderer
  },
  data() {
    return {
      navOpen: false,
      userOpen: false,
      moduleData: {},
      stepData: {},
      baseURL: config.API_URL,
      loading: true
    };
  },
  async mounted() {
    if (this.progress.progress === undefined) {
      console.log("missing course data or progress data, pull from state");
      await this.getCourseAction();
      await this.getProgressAction()
      //this.$router.push("/dashboard");
    } 
    this.setCourseActive(true);
    await this.getMoudle();
    await this.setStepData();
  },
  methods: {
    ...mapMutations("course", ["setCurrentStep"]),
    async getMoudle() {
      await CourseService.getModule(this.mod).then(data => {
        this.moduleData = data;
      });
    },
    setCurrentPos() {
      this.setCurrentStep({
        module: this.mod,
        step: this.step
      });
    },
    setStepData() {
      for (let i = 0; i < this.moduleData.steps.length; i++) {
        if (this.moduleData.steps[i].number.toString() === this.step) {
          this.stepData = this.moduleData.steps[i];
          this.loading = false;
        }
      }
    },
    setCourseActive(courseActive) {
      this.$store.commit("setCourseActive", courseActive);
    },
    ...mapActions("course", [
      "getCourseAction",
      "getProgressAction",
    ]),
  },
  computed: {
    step() {
      return this.$route.params.step;
    },
    mod() {
      return this.$route.params.module;
    },
    user() {
      return this.$store.state.auth.user;
    },
    progress() {
      return this.$store.state.course.progress;
    }
  },
  watch: {
    async mod() {
      await this.getMoudle();
      this.setStepData();
    },
    async step() {
      this.setStepData();
    }
  }
};
</script>

<style lang="scss" scoped>
.course {
}
</style>
